import { BodyText, Button, Headline, Icon, Popover, Stack } from '@servicetitan/design-system';
import { FC, ReactNode, useState } from 'react';

export const InfoTip: FC<{
    title: string;
    children?: ReactNode;
}> = ({ children, title }) => {
    const [open, setOpen] = useState(false);
    const handleIconClick = (event: MouseEvent) => {
        event.stopPropagation();
        event.preventDefault();
        setOpen(!open);
    };
    const handleClose = () => {
        setOpen(false);
    };

    return (
        <Popover
            trigger={
                <Icon
                    name="help"
                    size={16}
                    onClick={handleIconClick}
                    className="cursor-pointer c-neutral-90-i"
                />
            }
            open={open}
            portal
            sharp
            direction="br"
            width="s"
            padding="m"
            onClickOutside={handleClose}
        >
            <Headline size="medium">{title}</Headline>
            <div>{typeof children === 'string' ? <BodyText>{children}</BodyText> : children}</div>

            <Stack className="m-t-3 w-100" justifyContent="flex-end">
                <Button onClick={handleClose}>OK</Button>
            </Stack>
        </Popover>
    );
};

export const InfoTipLabel: FC<{
    label: string;
    title?: string;
    children?: ReactNode;
}> = ({ children, label, title }) => {
    return (
        <Stack>
            <BodyText className="m-r-1" size="small">
                {label}
            </BodyText>
            <InfoTip title={title ?? label}>{children}</InfoTip>
        </Stack>
    );
};
